import type { RumEvent } from "@datadog/browser-rum";

/**
 * Drops Pendo agent noise from RUM:
 *   - Origin: `pendo.io` in `error.stack` or `error.handling_stack` (Pendo's
 *     console errors carry it only in `handling_stack`).
 *   - Fallback: a Pendo "recording" phrase on a console error with no stack.
 *     Console-only, so first-party errors aren't matched.
 *
 * Keep in sync with pro-web's `pendo-rum-noise.util.ts` (v1.a and v1/shared).
 */

const PENDO_ORIGIN_PATTERN = /pendo\.io/i;
const PENDO_MESSAGE_PATTERN =
  /failed to send hosted resources for recording event|failed to (?:\(re-\)|re-)?fetch recording config|failed to send reason for stopping recording|failed to send recording data from web worker|session recording error/i;

export function isPendoRumNoise(event: RumEvent | null | undefined): boolean {
  if (event?.type !== "error") {
    return false;
  }
  const stack = event.error?.stack ?? "";
  const handlingStack = event.error?.handling_stack ?? "";
  if (
    PENDO_ORIGIN_PATTERN.test(stack) ||
    PENDO_ORIGIN_PATTERN.test(handlingStack)
  ) {
    return true;
  }
  if (event.error?.source === "console") {
    return PENDO_MESSAGE_PATTERN.test(event.error.message ?? "");
  }
  return false;
}
